import React from "react";
import styled from "styled-components";

const TextToAdd = ({ textToAdd, setTextToAdd }) => {
  return (
    <TextContainer>
      <p className="title"> Wordings</p>
      <input
        className="input"
        onChange={(e) => setTextToAdd(e.target.value)}
        type="text"
        placeholder="What should we write on cake?"
      />
    </TextContainer>
  );
};

export default TextToAdd;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
  .title {
    font-weight: 900;
    font-size: 20px;
    text-align: center;
  }

  .input {
    border-radius: 7px;
    height: 40px;
    width: 100%;
    border: 2px solid black;
    padding-left: 10px;
    font-weight: bold;
    background: none;
  }
  .input:focus {
    padding-left: 10px;
    font-weight: bold;
  }

  .input:placeholder-shown {
    padding-left: 10px;
  }
`;
